import React from "react";
import { Col } from "reactstrap";
import Adjuntos from "./Adjuntos";
import Diagnostico from "./Diagnostico";
import Facturacion from "./Facturacion";
import Delivery from "./Delivery";
import InfoCronico from "./InfoCronico";
import RegistroMedicamentosCronicos from "./RegistroMedicamentosCronicos";
import RegistroMedicamentosMercantil from "./RegistroMedicamentosMercantil";
import SolicitudesRelacionadas from "./SolicitudesRelacionadas";
import { tipoEfectivo } from "../../../utils/validaciones";
import { getMontoCobertura } from "../../../utils/solicitudDataCleaner";

const TicketDescription = ({ solicitud, usuarios, farmacias }) => {
  const tipoOp = tipoEfectivo(solicitud);
  return (
    <React.Fragment>
      <Col xxl={9}>
        <Adjuntos solicitud={solicitud} />

        {tipoOp === "Cronica" && <InfoCronico solicitud={solicitud} />}

        {tipoOp === "Aguda" && <Diagnostico solicitud={solicitud} />}

        {solicitud?.aseguradora === "Seguros Mercantil" && (
          <RegistroMedicamentosMercantil solicitud={solicitud} />
        )}

        {solicitud.montoCobertura > 0 && tipoOp === "Cronica" && (
          <>
            <RegistroMedicamentosCronicos solicitud={solicitud} />
          </>
        )}

        {((solicitud.diagnosticoFarmacologico != null) || 
          ((solicitud?.aseguradora?.toLowerCase() === "latina salud" || solicitud?.aseguradora?.toLowerCase() === "hispana de seguros" || solicitud?.aseguradora?.toLowerCase() === "real seguros") && solicitud.diagnostico && getMontoCobertura(solicitud.montoCobertura) > 0)) && (
          <Facturacion usuarios={usuarios} solicitud={solicitud} />
        )}

        <Delivery
          usuarios={usuarios}
          solicitud={solicitud}
          farmacias={farmacias}
        />

        <SolicitudesRelacionadas solicitud={solicitud} />
        
      </Col>
    </React.Fragment>
  );
};

export default TicketDescription;
